<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="col-lg-6">
        <fieldset>
          <EntityReferencesModal
            v-if="modalIsVisible"
            title="Пользователи"
            link-slug="users"
            :additional-filters="modalFilters"
            :preparing-data="form.users"
            :table-fields="modalTableFields"
            @choose="updateUsersList"
            @close="modalIsVisible = false"
            not-only-ids
          />
          <ReferencesList
            :label="label"
            slug="users"
            :item-description-fields="['login']"
            :list="form.users"
            :buttons-are-visible="!inputsWereDisabled"
            @on-plus-click="modalIsVisible = true"
            @on-delete="(values) => (form.users = values)"
          />
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
import ReferencesList from "@/_shared/components/ui/ReferencesList";
import EntityReferencesModal from "@/_shared/components/modals/EntityReferencesModal";
import { modals } from "@/_shared/constants";
export default {
  components: {
    ReferencesList,
    EntityReferencesModal,
  },
  props: {
    label: {
      type: String,
      default: 'Пользователи',
    },
    modalFilters: {
      type: Array | null,
      default() {
        return [];
      },
    },
    inputsWereDisabled: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default() {
        return {
          users: [],
        };
      },
    },
  },
  data() {
    return {
      modalIsVisible: false,
    };
  },
  computed: {
    modalTableFields() {
      return modals.users.fields;
    },
  },
  methods: {
    updateUsersList(values = null) {
      if (this.form.users.length < 1) {
        return (this.form.users = values);
      }
      this.form.users = [...this.form.users, ...values];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/user/widgets/users/UsersList.vue